import { usePermissionsRepository } from '@Hooks/useRepository';
import { ApiUserProfile } from '@Model';
import { OwnProfileRepository } from '@Repositories/Permissions';
import { isNullOrEmpty } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

interface OwnUserResult {
    profile: ApiUserProfile | undefined;
    isLoading: boolean;
    refetch: () => void;
}

export function useOwnUser(partnership: string): OwnUserResult {
    const ownProfile = usePermissionsRepository(OwnProfileRepository);

    const { data, isLoading, refetch } = useQuery({
        queryFn: () => ownProfile.getUserProfile(),
        enabled: !isNullOrEmpty(partnership),
        queryKey: ['users', 'me', partnership],
        refetchOnWindowFocus: false,
    });

    const triggerRefetch = useCallback(() => refetch(), [refetch]);

    return {
        profile: data?.data,
        isLoading,
        refetch: triggerRefetch,
    };
}
